import React from 'react';

function TableMidPart({ children }) {
    return <div className="blot-field__cards-score">{children}</div>;
}

export default TableMidPart;
